var exports = {
  "k": "xa15a2ab7--73dc44--container",
};

module.exports = exports;
